import { render, staticRenderFns } from "./OnlineSurvey.vue?vue&type=template&id=538e5564&"
import script from "./OnlineSurvey.vue?vue&type=script&lang=js&"
export * from "./OnlineSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports